


import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import TableContainerColumnTotal from "components/Common/TableContainerColumnTotal";
import TableContainer from "components/Common/TableContainer";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2';
import CustomSelect from "components/Common/custom-select";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchActiveEmployees, fetchCategory, fetchDepartment, fetchDesignation, getEmployeesCTCReport } from "store/actions";
import CustomMonthPicker from "common/CustomMonthPicker";
import useButtonAccess from "components/Common/useButtonAccess";
import classnames from "classnames";
import Loader from "common/pageLoader";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import "../../../../../pages/Employee/EmployeeDetails/style.css";

const PayrollReportCurrentCTC = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const [data, setdata] = useState(null);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchActiveEmployees(unitId));
    dispatch(fetchCategory(authUserDetails[0].unit_id));
    dispatch(fetchDepartment(authUserDetails[0].unit_id));
    dispatch(fetchDesignation(authUserDetails[0].unit_id));
  }, [dispatch]);

  const {
    employees,
    categoryList,
    departmentList,
    designationList,
    ctcreport,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    employees: state.EmployeeDetailsReducer?.employeesActiveList ?? [],
    departmentList: state.EmployeeDetailsReducer?.departmentList ?? [],
    designationList: state.EmployeeDetailsReducer?.designationList ?? [],
    categoryList: state.EmployeeDetailsReducer?.categoryList ?? [],
    ctcreport: state.PayrollReportsReducer?.ctcreport ?? [],
    loading: state.PayrollReportsReducer?.loading,
    error: state.PayrollReportsReducer?.error,
    success: state.PayrollReportsReducer?.success,
  }));

  let categoryOptions = [], deptOptions = [], desigOption = [], employeeslist = [];
  categoryOptions = (categoryList || []).map(item => ({ label: item.empCategory, value: item.empCatgryid }));
  deptOptions = (departmentList || []).map(item => ({ label: item.departmentcode, value: item.departmentId }));
  desigOption = (designationList || []).map(item => ({ label: item.designation, value: item.desig_id }));
  employeeslist = (employees || []).map(item => ({ label: item.emp_no, value: item.emp_id }));

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      empCode: "",
      empName: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("emp_cat", values.category?.value || 0);
      formData.append("emp_dep", values?.department?.value || 0);
      formData.append("design", values?.designation?.value || 0);
      formData.append("emp_code", values?.employee?.value || 0);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(getEmployeesCTCReport(formData));
    },
  });

  useEffect(() => {
    if (ctcreport?.length > 0) {
      const Data = ctcreport.map((emp, index) => ({
        sno: emp.s_no,
        code: emp.code,
        name: emp.name,
        gender: emp.gender,
        date_of_joining: emp.date_of_joining,
        category: emp.category,
        department: emp.department,
        designation: emp.designation,
        reporting_person: emp.reporting_person,
        experience: emp.experience,
        basic: emp.basic,
        da: emp.da,
        hra: emp.hra,
        conv: emp.conv,
        washing: emp.washing,
        gross: emp.gross,
        gross_year: emp.gross_year,
        employer_esi: emp.employer_esi,
        employer_pf: emp.employer_pf,
        ctc: emp.ctc,
      })) || [];

      setdata(Data);
    } else {
      dispatch({ type: "RESET_SAVE_STATUS" });
      setdata([]);
    }
  }, [ctcreport]);

  const columns = [
    { Header: "S#", Cell: ({ row }) => data.length - row.index, className: "serial-no", applyHeaderClass: true },
    { Header: "CODE", accessor: "code", className: "sticky-col-1" },
    { Header: "NAME", accessor: "name", className: "sticky-col-2" },
    { Header: "GENDER", accessor: "gender" },
    { Header: "DOJ", accessor: "date_of_joining" },
    { Header: "CATEGORY", accessor: "category" },
    { Header: "DESIGNATION", accessor: "designation" },
    { Header: "REPORTING_PERSON", accessor: "reporting_person" },
    { Header: "EXPERIENCE", accessor: "experience" },
    {
      Header: "BASIC", accessor: "basic", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.basic || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    {
      Header: "DA", accessor: "da", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.da || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    {
      Header: "HRA", accessor: "hra", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.hra || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    {
      Header: "CONVEYANCE", accessor: "conv", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.conv || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    {
      Header: "WASHING", accessor: "washing", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.washing || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    {
      Header: "GROSS_MONTH", accessor: "gross", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.gross || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    {
      Header: "GROSS_YEAR", accessor: "gross_year", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.gross_year || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    {
      Header: "EMPLOYER_PF", accessor: "employer_pf", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.employer_pf || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },
    { Header: "EMPLOYER_ESI", accessor: "eemployer_esi", },
    {
      Header: "EMPLOYEE_CTC", accessor: "ctc", className: "text-center",
      Footer: info => {
        const total = info.rows.reduce((sum, row) => sum + Number(row.values.ctc || 0), 0);
        return (
          <div style={{ fontWeight: "700", color: "#0c0c0c", backgroundColor: "#f2f7f5", padding: "6px", textAlign: "center", width: "100%" }}>
            {total.toLocaleString("en-IN")}
          </div>
        );
      }
    },

  ];

  const resetFormData = () => {
    dispatch({ type: "RESET_SAVE_STATUS" });
    formik.resetForm({
      values: {
        category: "",
        department: "",
        designation: "",
        employee: "",
      },
    });
    setdata([]);
  };

  return (
    <React.Fragment>
      <Loader loading={loading} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Payroll / Reports / Salary Reports" breadcrumbItem="Current CTC Report" />
          <Card>
            <CardBody>
              <form onSubmit={formik.handleSubmit}>
                <Row className="gy-3">
                  <Col md={2}>
                    <Label>Category</Label>
                    <CustomSelect
                      id="category"
                      name="category"
                      isMulti={false}
                      options={categoryOptions || []}
                      value={formik.values.category || null}
                      onChange={(selectedOption) => {
                        formik.setFieldValue("category", selectedOption); if (selectedOption) { }
                      }}
                      onBlur={() => formik.setFieldTouched("category", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </Col>

                  <Col md={2}>
                    <Label>Department</Label>
                    <CustomSelect
                      id="department"
                      name="department"
                      isMulti={false}
                      options={deptOptions || []}
                      value={formik.values.department || null}
                      onChange={(selectedOption) => { formik.setFieldValue("department", selectedOption); }}
                      onBlur={() => formik.setFieldTouched("department", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </Col>

                  <Col md={2}>
                    <Label>Designation</Label>
                    <CustomSelect
                      id="designation"
                      name="designation"
                      isMulti={false}
                      options={desigOption || []}
                      value={formik.values.designation || null}
                      onChange={(selectedOption) => { formik.setFieldValue("designation", selectedOption); }}
                      onBlur={() => formik.setFieldTouched("designation", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </Col>

                  <Col md={2}>
                    <Label>Employee Code</Label>
                    <CustomSelect
                      id="employee"
                      name="employee"
                      isMulti={false}
                      options={employees}
                      value={formik.values.employee || null}
                      onChange={(selectedOption) => { formik.setFieldValue("employee", selectedOption); }}
                      onBlur={() => formik.setFieldTouched("employee", true)}
                      className="react-select-container"
                      classNamePrefix="react-select"
                      isClearable={true}
                    />
                  </Col>
                  <Col className="d-flex align-items-center justify-content-end  mt-5">
                    <Button type="submit" className="btn button-search me-2 mt-2" ><i className="fas fa-search me-1" /> Search</Button>
                    <Button type="reset" className="btn button-cancel me-2 mt-2"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                          showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                        }).then((result) => {
                          if (result.isConfirmed) {
                            resetFormData();
                          }
                        });
                      }}
                    >
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-2">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(data, authDetails?.unit_fullname, authDetails?.unit_address, "WAGE_REGISTER")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>
                        <DropdownItem onClick={() => exportEmployeeToPDF(data, authDetails?.unit_fullname, authDetails?.unit_address, "WAGE_REGISTER", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </Col>
                </Row>
              </form>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <TableContainer columns={columns} data={data && data?.length > 0 ? data : []} isGlobalFilter={true} customPageSize={10} showFooter={true} />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollReportCurrentCTC;

